import React from "react";
import usePageMeta from "../../utils/usePageMeta";
import { servicesFAQs } from "../../constant/data";
import Section4 from "../../components/Section4";
import ProcessSection from "../../components/ProcessSection";
import FAQs from "../../components/FAQs";
import Section10 from "../../components/Section10";

const ServicesPage = () => {
  usePageMeta({
    title: "Services",
    description:
      "Mobile apps in Flutter and React Native, web apps in React and Next.js, admin dashboards, APIs, e-commerce, app store publishing and ongoing maintenance.",
    path: "/services",
  });
  return (
    <div className="mt-20 min-h-screen">
      <Section4 showAll />
      <ProcessSection />
      <FAQs faqs={servicesFAQs} />
      <Section10 />
    </div>
  );
};

export default ServicesPage;
